import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const WPF = () => {
  return (
    <StartInterviewLayout type="wpf"/>
  )
}

export default WPF;